import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Link from '@utility/Link';
import * as styles from './styles';

const Button = ({ to, children, className, small, outline, ...rest }) => {
  if (!to) {
    return (
      <button
        className={cn(className, styles.btn, {
          [styles.small]: small,
          [styles.outline]: outline
        })}
        {...rest}>
        <span>{children}</span>
      </button>
    );
  }

  return (
    <Link
      to={to}
      className={cn(className, styles.btn, {
        [styles.small]: small,
        [styles.outline]: outline
      })}
      {...rest}>
      <span>{children}</span>
    </Link>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

Button.defaultProps = {
  className: '',
  color: ''
};

export default Button;
